import type { GeoLevel, SelectedGeo } from '../types';
import { US_COUNTIES, type UsCounty } from './us-counties';
import { US_STATE_BY_FIPS } from './us-states';

export const US_COUNTY_BY_FIPS: ReadonlyMap<string, UsCounty> = new Map(
  US_COUNTIES.map((county) => [county.fips, county])
);

/** FIPS length discriminates the level: 2 digits = state, 5 = county. */
export function geoFromFips(fips: string): SelectedGeo | null {
  if (fips.length === 2) {
    const state = US_STATE_BY_FIPS.get(fips);
    if (!state) return null;
    return { level: 'state', fips, name: state.name, stateFips: fips };
  }
  const county = US_COUNTY_BY_FIPS.get(fips);
  if (!county) return null;
  const state = US_STATE_BY_FIPS.get(county.stateFips);
  return {
    level: 'county',
    fips,
    name: state ? `${county.name}, ${state.postal}` : county.name,
    stateFips: county.stateFips,
  };
}

/**
 * The geography a scenario sends to the MRIO `/invocations` endpoint. Counties
 * send their 5-digit FIPS; states send their 2-digit FIPS as-is. State grain
 * isn't accepted by the API yet (it's gated as unsupported in useImpact); this
 * still carries the state FIPS so it just works once the grain lands.
 */
export function impactRequestForGeo(geo: SelectedGeo): {
  fips: string;
  level: GeoLevel;
} {
  return { fips: geo.fips, level: geo.level };
}
